import { Box } from "@mui/material";
import dynamic from "next/dynamic";
const CircularProgress = dynamic(
  () => import("@mui/material/CircularProgress"),
  { ssr: false }
);

export interface ISpinner {
  spinColor?: any;
  resize?: string;
}

function Spinner({ spinColor, resize }: ISpinner) {
  return (
    <Box style={{ display: "flex", marginRight: "1rem" }}>
      <CircularProgress
        style={{ color: spinColor }}
        size={resize ? resize : "20px"}
      />
    </Box>
  );
}
export default Spinner;
